import React from "react"
import {Checkbox, Divider, Form, Row, Switch, Typography} from "antd";
import {CaretDownOutlined, CaretUpOutlined} from "@ant-design/icons";
import Utils from "utils/index"
import {IViewSettingsProps} from "../ViewSettings";
import {connect, RootStateOrAny} from "react-redux";
import selectors from "../../../../redux/selectors";
import IContentType from "../../../../model/interface/dataStorage/IContentType";
import DragSortList from "../../../shared/list/DragsortList";
import Collapse from "../../../shared/display/collapse/Collapse";
import arrayMove from "array-move";
import IViewFilterIslandItemSettings from "model/interface/dataStorage/view/settings/IViewFilterIslandItemSettings";
import IViewFilterIslandSettings from "../../../../model/interface/dataStorage/view/settings/IViewFilterIslandSettings";
import LocaleText from "../../settings/dictionary/LocaleText";

interface IProps extends IViewSettingsProps {
    findContentTypeByUuid: (uuid: string) => IContentType
}

class ViewFilterIslandSettings extends React.Component<IProps, { filterIsland: IViewFilterIslandSettings }> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            filterIsland: props.settings && props.settings.filterIsland
                ? Object.fromEntries(Object.entries(props.settings.filterIsland).map(([uuid, items]) => ([uuid, [
                    ...items.filter(item => props.view.items.find(tableItem => tableItem.field === item.field && tableItem.enabled && !!this.getField(item.field, uuid))),
                    ...props.view.items
                        .filter(item => !items?.find(tableItem => tableItem.field === item.field) && item.enabled && !!this.getField(item.field, uuid))
                        .map(item => ({
                            field: item.field,
                            enabled: false
                        }))
                ]])))
                : Object.fromEntries(props.view.contentTypes.map(c => ([c, props.view.items.filter(item => item.enabled && !!this.getField(item.field, c)).map(item => ({
                    field: item.field,
                    enabled: false
                }))])))
        }
    }

    onSortEnd = ({oldIndex, newIndex}: { oldIndex: number, newIndex: number }, contentTypeUuid: string): void => {
        const {settings, onChange} = this.props
        let filterIsland = this.getFilters()[contentTypeUuid]
        filterIsland = arrayMove(filterIsland, oldIndex, newIndex)
        this.setState(state => ({filterIsland: {...state.filterIsland, [contentTypeUuid]: filterIsland}}));
        onChange({filterIsland: {...settings?.filterIsland, [contentTypeUuid]: filterIsland}}).then()
    }

    getFilters() {
        return this.state.filterIsland || [];
    }

    onChange = (item: IViewFilterIslandItemSettings, values: any, contentTypeUuid: string) => {
        const {settings, onChange} = this.props
        let filters = this.getFilters()[contentTypeUuid]
        const index = Utils.findIndex(filters, {field: item.field})
        filters[index] = {...filters[index], ...values}
        this.setState(state => ({filterIsland: {...state.filterIsland, [contentTypeUuid]: filters}}));
        onChange({filterIsland: {...settings?.filterIsland, [contentTypeUuid]: filters}}).then()
    }

    getField = (value: string, contentTypeUuid: string, property: 'uuid' | 'name' = 'uuid') => {
        const {findContentTypeByUuid} = this.props
        const contentType = findContentTypeByUuid(contentTypeUuid)
        return contentType.fields.find(f => f[property] === value)
    }

    getViewItem = (field: string) => {
        const {view} = this.props
        return view.items.find(viewItem => viewItem.field === field)
    }

    render() {
        const {view, findContentTypeByUuid, onChange} = this.props

        const {filterIsland} = this.state

        return (
            <>
                {view.contentTypes.map(uuid =>
                    <div>
                        <Form.Item label={'Průběžně ukládat'}>
                            <Switch onChange={e => onChange({filterIslandSaveState: e})}/>
                        </Form.Item>
                        {view.contentTypes.length > 1 && (
                            <Divider type={'horizontal'}>
                                <LocaleText code={findContentTypeByUuid(uuid).label || ''}/>
                            </Divider>
                        )}
                        {this.buildItemList(filterIsland[uuid] || [], uuid)}
                    </div>
                )}

            </>
        );
    }

    buildItemList(children: IViewFilterIslandItemSettings[], contentTypeUuid: string) {
        return <DragSortList item={{
            render: (value: IViewFilterIslandItemSettings, _, handle) => {
                const {field, enabled, defaultVisible} = value
                const viewItem = this.getViewItem(field)
                const fieldObject = this.getField(field, contentTypeUuid)
                if (!field || !fieldObject) {
                    throw new Error('missing field on view item')
                }
                const {name, label} = fieldObject
                const title = viewItem?.options?.label || label
                return (
                    <Collapse header={(_, _trigger) =>
                        <Row justify={'space-between'}>
                            <Row align={"middle"}>
                                {handle}
                                <Divider type={"vertical"}/>
                                <Checkbox className={'mr-2'} checked={enabled}
                                          onChange={(event) =>
                                              this.onChange(value, {enabled: event.target.checked}, contentTypeUuid)}/>
                                {title &&
                                    <Typography.Text strong className={'mr-2'}><LocaleText code={title}/></Typography.Text>}({name})
                            </Row>
                            <Row align={"middle"}>
                                Vždy zobrazit: <Switch className={'ml-2'} defaultChecked={defaultVisible}
                                                       onChange={defaultVisible => this.onChange(value, {defaultVisible}, contentTypeUuid)}/>
                            </Row>
                        </Row>}>
                    </Collapse>
                )
            },
            className: 'border p-1 px-2 mb-2 shadow-sm'
        }} children={children} lockAxis={"y"} handle={{
            render: () => <div className={'d-inline-block'}>
                <div className={"d-flex flex-column px-1"} style={{cursor: "move"}}>
                    <CaretUpOutlined/>
                    <CaretDownOutlined/>
                </div>
            </div>
        }} onSortEnd={end => this.onSortEnd(end, contentTypeUuid)}/>;
    }
}

const mapStateToProps = (state: RootStateOrAny) => {
    return {
        findContentTypeByUuid: (uuid: string) => selectors.contentTypes.findOneBy(state, 'uuid', uuid)
    }
}

export default connect(mapStateToProps)(ViewFilterIslandSettings)